import { VIDEO_DEVICE_LOST } from 'actions/Types';
import { toggleVideoActive } from 'actions/Broadcast';
import { PRESENTER } from 'constants/Views';
import { StudioLogger } from '@studio/logger/StudioLogger';

const logger = new StudioLogger('meeting');

/**
 * Handles the change event when the video input device is changed.
 *
 * @param {Array} deviceList - The list of available video input devices.
 * @returns {Function} - A Redux thunk function.
 */
function handleVideoInputChanged(deviceList = []) {
  return (dispatch, getState) => {
    const {
      attendeeCameraStatus,
      videoInputDevice,
      meeting: { attendeeResponse }
    } = getState();
    const attendeeId = attendeeResponse?.Attendee?.AttendeeId;
    const attendeeVideoActive = attendeeCameraStatus[attendeeId];

    const newDeviceWithSameID = deviceList.find(
      device => device.deviceId === videoInputDevice
    );
    if (!newDeviceWithSameID && attendeeVideoActive === true) {
      const logPayload = {
        videoInputDevice,
        attendeeId,
        title: `The video device ${videoInputDevice} of Attendee ${attendeeId} has been disconnected.`,
        view: PRESENTER
      };
      logger.info(logPayload.title, logPayload);
      const action = {
        type: VIDEO_DEVICE_LOST,
        payload: true
      };
      dispatch(action);
      dispatch(toggleVideoActive());
    }
  };
}

export default handleVideoInputChanged;
